import Vue from 'vue';

Vue.filter('truncate', function(value, limit) {
    return value.substring(0, limit);
});
